import SkeletonLoader from "../SkeletonLoader"

const TableCardSkeleton = () => {
  const rowHeight = 40
  const rowClassName = "w-full flex-1"
  return (
    <div className="flex flex-col rounded-lg border-solid border-[1px] border-gray-200 p-2">
      <div className="w-full flex flex-col">
        {[...Array(6)].map((_, idx) => (
          <div className={rowClassName} key={`skeleton-row-${idx}`}>
            <SkeletonLoader height={rowHeight} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default TableCardSkeleton
